import { render, staticRenderFns } from "./status-success.component.vue?vue&type=template&id=33306444"
import script from "./status-success.component.ts?vue&type=script&lang=ts&external"
export * from "./status-success.component.ts?vue&type=script&lang=ts&external"
import style0 from "./status-success.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports